import { Typography } from "@platform/design-system";

export const CarrierRulesTab = (): React.JSX.Element => (
  <Typography variant="header-small" component="h2">
    Rules tab
  </Typography>
);
